import { useEffect, useState } from "react";
import { supabase } from "../supabaseClient";
import { S } from "../theme";

const SEED_POSTS = [
  {
    id: "p1", author: "Marcus R.", initials: "MR", color: "#2d6a4f",
    category: "Recovery", title: "Week 6 BPC-157 update — knee finally responding",
    body: "Been running BPC-157 at 250mcg subQ daily for 6 weeks now. Background: chronic patellar tendinopathy that's been bothering me for 2 years. Week 1-3 basically nothing noticeable. Week 4 I started noticing I could go up stairs without that familiar ache. Now at week 6 I did my first full squat session in 18 months. Not pain free but like 80% better. Stacking with TB-500 2x/week. Anyone else see results kick in around week 4-5?",
    likes: 47, timestamp: Date.now() - 1000 * 60 * 60 * 3,
    replies: [
      { id: "r1", author: "Jake T.", initials: "JT", color: "#6b4fbb", body: "Yes exactly this. Results for me came around day 30. The first few weeks I was ready to give up. Keep going.", likes: 12, timestamp: Date.now() - 1000 * 60 * 60 * 2 },
      { id: "r2", author: "Sarah M.", initials: "SM", color: "#e76f3b", body: "What reconstitution ratio are you using? I've been at 250mcg too but wondering if I should bump to 500.", likes: 8, timestamp: Date.now() - 1000 * 60 * 90 },
    ]
  },
  {
    id: "p2", author: "Jessica L.", initials: "JL", color: "#8b5cf6",
    category: "GLP-1", title: "Semaglutide + GHK-Cu combo for women — my 8 week experience",
    body: "Running 0.5mg sema weekly plus 1mg GHK-Cu daily for skin. The combination has been incredible for body recomp. Down 14lbs in 8 weeks but what's surprising is my skin actually looks better instead of worse (which I was worried about with the weight loss). The GHK-Cu seems to be helping with collagen maintenance. Sharing because I couldn't find much info on women running this combo.",
    likes: 89, timestamp: Date.now() - 1000 * 60 * 60 * 8,
    replies: [
      { id: "r3", author: "Priya K.", initials: "PK", color: "#0891b2", body: "This is exactly what I was looking for. How are you dosing the GHK-Cu — morning or evening?", likes: 15, timestamp: Date.now() - 1000 * 60 * 60 * 7 },
      { id: "r4", author: "Jessica L.", initials: "JL", color: "#8b5cf6", body: "Morning subQ on an empty stomach. I rotate sites between abdomen and outer thigh.", likes: 22, timestamp: Date.now() - 1000 * 60 * 60 * 6 },
      { id: "r5", author: "Dana W.", initials: "DW", color: "#059669", body: "14lbs in 8 weeks is great. Are you eating at a significant deficit or letting the sema do the work?", likes: 9, timestamp: Date.now() - 1000 * 60 * 60 * 5 },
    ]
  },
  {
    id: "p3", author: "Derek K.", initials: "DK", color: "#e76f3b",
    category: "GH Peptides", title: "CJC-1295 + Ipamorelin sleep quality is no joke",
    body: "3 weeks into CJC/Ipa stack. 100mcg CJC + 200mcg Ipa pre-bed. My Oura ring HRV has gone from avg 45 to 68 in 3 weeks. Deep sleep up 40 min per night on average. I wake up feeling like I actually slept. Not a single side effect besides mild face flushing the first few days. If you're not tracking your biomarkers alongside your peptide protocol you're flying blind.",
    likes: 63, timestamp: Date.now() - 1000 * 60 * 60 * 24,
    replies: [
      { id: "r6", author: "Tom B.", initials: "TB", color: "#dc2626", body: "What time before bed are you pinning? I've heard 30-60 min but curious what works for you.", likes: 11, timestamp: Date.now() - 1000 * 60 * 60 * 23 },
    ]
  },
  {
    id: "p4", author: "Priya K.", initials: "PK", color: "#0891b2",
    category: "FDA Updates", title: "Summary of where things stand post-RFK announcement",
    body: "Trying to compile what we actually know vs speculation after the Feb 2026 announcement. CONFIRMED: RFK stated intention to return 14 peptides to compounding. NOT CONFIRMED: Timeline, specific list, whether this needs congressional action. STILL GRAY AREA: BPC-157 technically still on Category 2 list until formal rulemaking. MY TAKE: Compounding pharmacies are not changing overnight. If you have a physician relationship, now is the time to lock in prescriptions before rules firm up. Don't panic buy from research chem sites.",
    likes: 134, timestamp: Date.now() - 1000 * 60 * 60 * 48,
    replies: [
      { id: "r7", author: "Marcus R.", initials: "MR", color: "#2d6a4f", body: "This is the most level headed take I've seen. Bookmarking.", likes: 28, timestamp: Date.now() - 1000 * 60 * 60 * 47 },
      { id: "r8", author: "Lisa H.", initials: "LH", color: "#7c3aed", body: "Do we know which 14 specifically? I've seen different lists floating around.", likes: 19, timestamp: Date.now() - 1000 * 60 * 60 * 46 },
      { id: "r9", author: "Priya K.", initials: "PK", color: "#0891b2", body: "Not confirmed officially. The names floating around are BPC-157, TB-500, CJC-1295, Ipamorelin, Sermorelin, PT-141, Epithalon, GHK-Cu, Selank, Semax, MOTS-c, AOD-9604, Tesamorelin, and Thymosin Alpha-1. But treat that as unofficial until rulemaking.", likes: 41, timestamp: Date.now() - 1000 * 60 * 60 * 45 },
    ]
  },
];

const CATEGORIES = ["All", "Recovery", "GLP-1", "GH Peptides", "Anti-Aging", "Cognitive", "FDA Updates", "General"];

function timeAgoStr(ts) {
  const diff = Date.now() - ts;
  const m = Math.floor(diff / 60000);
  if (m < 1) return "just now";
  if (m < 60) return m + "m ago";
  const h = Math.floor(m / 60);
  if (h < 24) return h + "h ago";
  return Math.floor(h / 24) + "d ago";
}

function Community({ user }) {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);
  const [category, setCategory] = useState("All");
  const [view, setView] = useState("feed"); // feed | new_post | post
  const [activePost, setActivePost] = useState(null);
  const [newTitle, setNewTitle] = useState("");
  const [newBody, setNewBody] = useState("");
  const [newCat, setNewCat] = useState("General");
  const [replyText, setReplyText] = useState("");
  const [likedPosts, setLikedPosts] = useState(() => { try { return JSON.parse(localStorage.getItem("tmp_liked_posts") || "[]"); } catch { return []; } });
  const [likedReplies, setLikedReplies] = useState(() => { try { return JSON.parse(localStorage.getItem("tmp_liked_replies") || "[]"); } catch { return []; } });

  useEffect(() => { localStorage.setItem("tmp_liked_posts", JSON.stringify(likedPosts)); }, [likedPosts]);
  useEffect(() => { localStorage.setItem("tmp_liked_replies", JSON.stringify(likedReplies)); }, [likedReplies]);

  // Load posts + replies from database
  useEffect(() => { loadPosts(); checkAdmin(); }, []);

  async function checkAdmin() {
    const { data } = await supabase.from("profiles").select("is_admin").eq("id", user.id).single();
    setIsAdmin(!!data?.is_admin);
  }

  async function loadPosts() {
    setLoading(true);
    const { data: postRows } = await supabase.from("community_posts").select("*").order("created_at", { ascending: false });
    const { data: replyRows } = await supabase.from("community_replies").select("*").order("created_at");
    const replysByPost = {};
    (replyRows || []).forEach(r => {
      (replysByPost[r.post_id] = replysByPost[r.post_id] || []).push({
        id: r.id, user_id: r.user_id, author: r.author, initials: r.initials, color: r.color,
        body: r.body, likes: r.likes, timestamp: new Date(r.created_at).getTime(),
      });
    });
    setPosts((postRows || []).map(p => ({
      id: p.id, user_id: p.user_id, author: p.author, initials: p.initials, color: p.color,
      category: p.category, title: p.title, body: p.body, likes: p.likes,
      timestamp: new Date(p.created_at).getTime(), replies: replysByPost[p.id] || [],
    })));
    setLoading(false);
  }

  const filtered = posts.filter(p => category === "All" || p.category === category);

  async function submitPost() {
    if (!newTitle.trim() || !newBody.trim()) return;
    const initials = user.name.split(" ").map(w => w[0]).join("").slice(0,2).toUpperCase();
    await supabase.from("community_posts").insert({
      user_id: user.id, author: user.name, initials, color: S.accent,
      category: newCat, title: newTitle.trim(), body: newBody.trim(), likes: 0,
    });
    setNewTitle(""); setNewBody(""); setNewCat("General");
    setView("feed");
    loadPosts();
  }

  async function submitReply(postId) {
    if (!replyText.trim()) return;
    const initials = user.name.split(" ").map(w => w[0]).join("").slice(0,2).toUpperCase();
    await supabase.from("community_replies").insert({
      post_id: postId, user_id: user.id, author: user.name, initials, color: S.accent,
      body: replyText.trim(), likes: 0,
    });
    setReplyText("");
    await loadPosts();
    // refresh active post
    const { data: refreshed } = await supabase.from("community_replies").select("*").eq("post_id", postId).order("created_at");
    setActivePost(prev => prev ? { ...prev, replies: (refreshed || []).map(r => ({ id: r.id, user_id: r.user_id, author: r.author, initials: r.initials, color: r.color, body: r.body, likes: r.likes, timestamp: new Date(r.created_at).getTime() })) } : prev);
  }

  async function deletePost(postId) {
    if (!window.confirm("Delete this post permanently?")) return;
    await supabase.from("community_posts").delete().eq("id", postId);
    setView("feed");
    setActivePost(null);
    loadPosts();
  }

  async function deleteReply(replyId, postId) {
    if (!window.confirm("Delete this reply?")) return;
    await supabase.from("community_replies").delete().eq("id", replyId);
    await loadPosts();
    const { data: refreshed } = await supabase.from("community_replies").select("*").eq("post_id", postId).order("created_at");
    setActivePost(prev => prev ? { ...prev, replies: (refreshed || []).map(r => ({ id: r.id, user_id: r.user_id, author: r.author, initials: r.initials, color: r.color, body: r.body, likes: r.likes, timestamp: new Date(r.created_at).getTime() })) } : prev);
  }

  async function toggleLikePost(postId) {
    const liked = likedPosts.includes(postId);
    const post = posts.find(p => p.id === postId);
    const newLikes = (post?.likes || 0) + (liked ? -1 : 1);
    setLikedPosts(prev => liked ? prev.filter(id => id !== postId) : [...prev, postId]);
    setPosts(prev => prev.map(p => p.id === postId ? { ...p, likes: newLikes } : p));
    if (activePost?.id === postId) setActivePost(prev => ({ ...prev, likes: newLikes }));
    await supabase.from("community_posts").update({ likes: newLikes }).eq("id", postId);
  }

  async function toggleLikeReply(postId, replyId) {
    const liked = likedReplies.includes(replyId);
    const post = posts.find(p => p.id === postId);
    const reply = post?.replies.find(r => r.id === replyId);
    const newLikes = (reply?.likes || 0) + (liked ? -1 : 1);
    setLikedReplies(prev => liked ? prev.filter(id => id !== replyId) : [...prev, replyId]);
    setPosts(prev => prev.map(p => p.id === postId ? { ...p, replies: p.replies.map(r => r.id === replyId ? { ...r, likes: newLikes } : r) } : p));
    if (activePost?.id === postId) setActivePost(prev => ({ ...prev, replies: prev.replies.map(r => r.id === replyId ? { ...r, likes: newLikes } : r) }));
    await supabase.from("community_replies").update({ likes: newLikes }).eq("id", replyId);
  }

  function openPost(post) {
    const latest = posts.find(p => p.id === post.id) || post;
    setActivePost(latest);
    setView("post");
    setReplyText("");
  }

  const canDelete = (ownerId) => isAdmin || ownerId === user.id;

  const Avatar = ({ initials, color, size = 40 }) => (
    <div style={{ width: size, height: size, borderRadius: "50%", background: `linear-gradient(135deg, ${color}, ${color}99)`, display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "'Fraunces', serif", fontWeight: 900, color: "#fff", fontSize: size * 0.35 + "rem", flexShrink: 0 }}>
      {initials}
    </div>
  );

  const CategoryBadge = ({ cat }) => {
    const colors = { Recovery: "#2d6a4f", "GLP-1": "#0284c7", "GH Peptides": "#e76f3b", "Anti-Aging": "#0891b2", Cognitive: "#7c3aed", "FDA Updates": "#dc2626", General: "#8c8478" };
    const c = colors[cat] || S.muted;
    return <span style={{ background: c + "18", color: c, border: `1px solid ${c}33`, fontSize: "0.62rem", fontWeight: 700, letterSpacing: "0.06em", padding: "3px 10px", borderRadius: 100 }}>{cat}</span>;
  };

  // ── POST DETAIL VIEW
  if (view === "post" && activePost) {
    const post = posts.find(p => p.id === activePost.id) || activePost;
    return (
      <div style={{ padding: 40, maxWidth: 760, margin: "0 auto" }}>
        <button onClick={() => { setView("feed"); setActivePost(null); }} style={{ background: "none", border: "none", cursor: "pointer", color: S.muted, fontSize: "0.82rem", fontWeight: 600, marginBottom: 24, display: "flex", alignItems: "center", gap: 6, padding: 0 }}>
          ← Back to Community
        </button>

        <div style={{ background: S.white, border: `1px solid ${S.border}`, borderRadius: 20, padding: 32, marginBottom: 20 }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 16 }}>
            <CategoryBadge cat={post.category} />
            <span style={{ fontSize: "0.72rem", color: S.muted }}>{timeAgoStr(post.timestamp)}</span>
          </div>
          <h2 style={{ fontFamily: "'Fraunces', serif", fontSize: "1.5rem", fontWeight: 700, color: S.ink, letterSpacing: "-0.02em", marginBottom: 16, lineHeight: 1.3 }}>{post.title}</h2>
          <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 20 }}>
            <Avatar initials={post.initials} color={post.color} size={36} />
            <span style={{ fontWeight: 600, fontSize: "0.88rem", color: S.ink2 }}>{post.author}</span>
          </div>
          <p style={{ fontSize: "0.9rem", color: S.ink2, lineHeight: 1.85, whiteSpace: "pre-wrap" }}>{post.body}</p>
          <div style={{ marginTop: 24, paddingTop: 20, borderTop: `1px solid ${S.border}`, display: "flex", alignItems: "center", gap: 20 }}>
            <button onClick={() => toggleLikePost(post.id)} style={{ display: "flex", alignItems: "center", gap: 6, background: likedPosts.includes(post.id) ? S.accentLight : "transparent", border: `1px solid ${likedPosts.includes(post.id) ? S.accent + "44" : S.border}`, borderRadius: 100, padding: "7px 16px", cursor: "pointer", color: likedPosts.includes(post.id) ? S.accent : S.muted, fontWeight: 600, fontSize: "0.82rem", fontFamily: "'Inter', sans-serif", transition: "all 0.2s" }}>
              ♥ {post.likes}
            </button>
            <span style={{ fontSize: "0.8rem", color: S.muted }}>{post.replies.length} {post.replies.length === 1 ? "reply" : "replies"}</span>
            {canDelete(post.user_id) && (
              <button onClick={() => deletePost(post.id)} style={{ marginLeft: "auto", display: "flex", alignItems: "center", gap: 5, background: S.accent2Light, border: "1px solid #fca5a555", borderRadius: 100, padding: "7px 16px", cursor: "pointer", color: "#dc2626", fontWeight: 600, fontSize: "0.78rem", fontFamily: "'Inter', sans-serif" }}>
                🗑 Delete{isAdmin && post.user_id !== user.id ? " (admin)" : ""}
              </button>
            )}
          </div>
        </div>

        {/* Replies */}
        {post.replies.length > 0 && (
          <div style={{ display: "flex", flexDirection: "column", gap: 12, marginBottom: 20 }}>
            {post.replies.map(r => (
              <div key={r.id} style={{ background: S.white, border: `1px solid ${S.border}`, borderRadius: 16, padding: "20px 24px", marginLeft: 24 }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                    <Avatar initials={r.initials} color={r.color} size={30} />
                    <span style={{ fontWeight: 600, fontSize: "0.85rem", color: S.ink2 }}>{r.author}</span>
                  </div>
                  <span style={{ fontSize: "0.7rem", color: S.muted }}>{timeAgoStr(r.timestamp)}</span>
                </div>
                <p style={{ fontSize: "0.87rem", color: S.ink2, lineHeight: 1.75, margin: 0 }}>{r.body}</p>
                <div style={{ display: "flex", alignItems: "center", gap: 16, marginTop: 12 }}>
                  <button onClick={() => toggleLikeReply(post.id, r.id)} style={{ display: "flex", alignItems: "center", gap: 5, background: "none", border: "none", cursor: "pointer", color: likedReplies.includes(r.id) ? S.accent : S.muted, fontSize: "0.78rem", fontWeight: 600, padding: 0, fontFamily: "'Inter', sans-serif" }}>
                    ♥ {r.likes}
                  </button>
                  {canDelete(r.user_id) && (
                    <button onClick={() => deleteReply(r.id, post.id)} style={{ background: "none", border: "none", cursor: "pointer", color: "#dc2626", fontSize: "0.74rem", fontWeight: 600, padding: 0, fontFamily: "'Inter', sans-serif" }}>
                      🗑 Delete
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Reply box */}
        <div style={{ background: S.white, border: `1px solid ${S.border}`, borderRadius: 16, padding: 24 }}>
          <div style={{ fontSize: "0.78rem", fontWeight: 700, color: S.ink2, marginBottom: 12 }}>Add a reply</div>
          <textarea
            value={replyText}
            onChange={e => setReplyText(e.target.value)}
            placeholder="Share your experience or answer..."
            rows={4}
            style={{ width: "100%", padding: "12px 16px", border: `1.5px solid ${S.border}`, borderRadius: 12, fontSize: "0.88rem", fontFamily: "'Inter', sans-serif", background: S.bg, color: S.ink, outline: "none", resize: "vertical", boxSizing: "border-box", lineHeight: 1.6 }}
          />
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 12 }}>
            <span style={{ fontSize: "0.72rem", color: S.muted }}>Be helpful, be specific, be kind.</span>
            <button onClick={() => submitReply(post.id)} disabled={!replyText.trim()} style={{ fontFamily: "'Inter', sans-serif", fontWeight: 700, fontSize: "0.85rem", color: "#fff", background: replyText.trim() ? S.accent : "#ccc", border: "none", padding: "10px 22px", borderRadius: 100, cursor: replyText.trim() ? "pointer" : "not-allowed", transition: "all 0.2s" }}>
              Post Reply →
            </button>
          </div>
        </div>
      </div>
    );
  }

  // ── NEW POST VIEW
  if (view === "new_post") {
    return (
      <div style={{ padding: 40, maxWidth: 700, margin: "0 auto" }}>
        <button onClick={() => setView("feed")} style={{ background: "none", border: "none", cursor: "pointer", color: S.muted, fontSize: "0.82rem", fontWeight: 600, marginBottom: 24, display: "flex", alignItems: "center", gap: 6, padding: 0 }}>
          ← Back
        </button>
        <h2 style={{ fontFamily: "'Fraunces', serif", fontSize: "1.6rem", fontWeight: 900, color: S.ink, letterSpacing: "-0.03em", marginBottom: 8 }}>New Post</h2>
        <p style={{ color: S.muted, fontSize: "0.85rem", marginBottom: 32 }}>Share your experience, ask a question, or post an update.</p>

        <div style={{ background: S.white, border: `1px solid ${S.border}`, borderRadius: 20, padding: 32 }}>
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: "block", fontSize: "0.78rem", fontWeight: 600, color: S.ink2, marginBottom: 6 }}>Category</label>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
              {CATEGORIES.filter(c => c !== "All").map(c => (
                <button key={c} onClick={() => setNewCat(c)} style={{ padding: "7px 14px", borderRadius: 100, border: `1.5px solid ${newCat === c ? S.accent : S.border}`, background: newCat === c ? S.accentLight : "transparent", color: newCat === c ? S.accent : S.muted, fontSize: "0.78rem", fontWeight: 600, cursor: "pointer", fontFamily: "'Inter', sans-serif", transition: "all 0.15s" }}>
                  {c}
                </button>
              ))}
            </div>
          </div>

          <div style={{ marginBottom: 16 }}>
            <label style={{ display: "block", fontSize: "0.78rem", fontWeight: 600, color: S.ink2, marginBottom: 6 }}>Title</label>
            <input value={newTitle} onChange={e => setNewTitle(e.target.value)} placeholder="What's your post about?" style={{ width: "100%", padding: "12px 16px", border: `1.5px solid ${S.border}`, borderRadius: 12, fontSize: "0.9rem", fontFamily: "'Inter', sans-serif", background: S.bg, color: S.ink, outline: "none", boxSizing: "border-box" }} />
          </div>

          <div style={{ marginBottom: 24 }}>
            <label style={{ display: "block", fontSize: "0.78rem", fontWeight: 600, color: S.ink2, marginBottom: 6 }}>Post</label>
            <textarea value={newBody} onChange={e => setNewBody(e.target.value)} placeholder="Share your protocol details, results, questions, or experience. The more specific, the more helpful." rows={8} style={{ width: "100%", padding: "12px 16px", border: `1.5px solid ${S.border}`, borderRadius: 12, fontSize: "0.88rem", fontFamily: "'Inter', sans-serif", background: S.bg, color: S.ink, outline: "none", resize: "vertical", boxSizing: "border-box", lineHeight: 1.7 }} />
          </div>

          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <p style={{ fontSize: "0.72rem", color: S.muted, maxWidth: 380, lineHeight: 1.6 }}>⚠️ Educational sharing only. Do not give or ask for medical advice. Be specific about your own experience.</p>
            <button onClick={submitPost} disabled={!newTitle.trim() || !newBody.trim()} style={{ fontFamily: "'Inter', sans-serif", fontWeight: 700, fontSize: "0.9rem", color: "#fff", background: (newTitle.trim() && newBody.trim()) ? S.accent : "#ccc", border: "none", padding: "13px 28px", borderRadius: 100, cursor: (newTitle.trim() && newBody.trim()) ? "pointer" : "not-allowed", transition: "all 0.2s", boxShadow: (newTitle.trim() && newBody.trim()) ? "0 4px 16px rgba(45,106,79,0.25)" : "none" }}>
              Post to Community →
            </button>
          </div>
        </div>
      </div>
    );
  }

  // ── FEED VIEW
  return (
    <div style={{ padding: 40 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 8 }}>
        <div>
          <h2 style={{ fontFamily: "'Fraunces', serif", fontSize: "1.8rem", fontWeight: 900, color: S.ink, letterSpacing: "-0.03em", margin: 0 }}>Community</h2>
          <p style={{ color: S.muted, fontSize: "0.85rem", marginTop: 6 }}>Real experiences from real peptide users. No chaos, no spam.</p>
        </div>
        <button onClick={() => setView("new_post")} style={{ fontFamily: "'Inter', sans-serif", fontWeight: 700, fontSize: "0.88rem", color: "#fff", background: S.accent, border: "none", padding: "12px 24px", borderRadius: 100, cursor: "pointer", boxShadow: "0 4px 16px rgba(45,106,79,0.25)", flexShrink: 0 }}>
          + New Post
        </button>
      </div>

      {/* Category filter */}
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 28, marginTop: 20 }}>
        {CATEGORIES.map(c => (
          <button key={c} onClick={() => setCategory(c)} style={{ padding: "8px 16px", borderRadius: 100, border: `1.5px solid ${category === c ? S.accent : S.border}`, background: category === c ? S.accentLight : S.white, color: category === c ? S.accent : S.muted, fontSize: "0.8rem", fontWeight: 600, cursor: "pointer", fontFamily: "'Inter', sans-serif", transition: "all 0.2s" }}>
            {c}
          </button>
        ))}
      </div>

      {/* Pinned notice */}
      <div style={{ background: S.accentLight, border: `1px solid ${S.accent}33`, borderRadius: 14, padding: "12px 18px", marginBottom: 20, display: "flex", gap: 10, alignItems: "center" }}>
        <span style={{ fontSize: "1rem" }}>📌</span>
        <span style={{ fontSize: "0.8rem", color: S.ink2, lineHeight: 1.6 }}>
          <strong>Community guidelines:</strong> Share your own experience. Be specific. No sourcing requests. No medical advice. Respect each other.
        </span>
      </div>

      {/* Posts */}
      <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
        {loading && (
          <div style={{ textAlign: "center", padding: 60, color: S.muted }}>
            <div style={{ fontSize: "2rem", marginBottom: 12 }}>💬</div>
            <div style={{ fontWeight: 600 }}>Loading community…</div>
          </div>
        )}
        {!loading && filtered.length === 0 && (
          <div style={{ textAlign: "center", padding: 60, color: S.muted }}>
            <div style={{ fontSize: "2.5rem", marginBottom: 12 }}>💬</div>
            <div style={{ fontWeight: 600 }}>No posts yet.</div>
            <p style={{ fontSize: "0.85rem", marginTop: 6 }}>Be the first to share your experience!</p>
          </div>
        )}
        {!loading && filtered.map(post => (
          <div key={post.id} onClick={() => openPost(post)} style={{ background: S.white, border: `1px solid ${S.border}`, borderRadius: 18, padding: "22px 26px", cursor: "pointer", transition: "all 0.2s" }}
            onMouseEnter={e => { e.currentTarget.style.borderColor = S.accent + "44"; e.currentTarget.style.transform = "translateY(-2px)"; }}
            onMouseLeave={e => { e.currentTarget.style.borderColor = S.border; e.currentTarget.style.transform = "translateY(0)"; }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 12 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <div style={{ width: 8, height: 8, borderRadius: "50%", background: post.color }} />
                <span style={{ fontWeight: 700, fontSize: "0.85rem", color: S.ink2 }}>{post.author}</span>
                <CategoryBadge cat={post.category} />
              </div>
              <span style={{ fontSize: "0.7rem", color: S.muted, flexShrink: 0 }}>{timeAgoStr(post.timestamp)}</span>
            </div>
            <h3 style={{ fontFamily: "'Fraunces', serif", fontWeight: 700, fontSize: "1.05rem", color: S.ink, letterSpacing: "-0.01em", marginBottom: 10, lineHeight: 1.3 }}>{post.title}</h3>
            <p style={{ fontSize: "0.82rem", color: S.muted, lineHeight: 1.7, marginBottom: 16, overflow: "hidden", display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical" }}>{post.body}</p>
            <div style={{ display: "flex", gap: 20, alignItems: "center" }}>
              <span style={{ fontSize: "0.78rem", color: likedPosts.includes(post.id) ? S.accent : S.muted, fontWeight: 600 }}>♥ {post.likes}</span>
              <span style={{ fontSize: "0.78rem", color: S.muted, fontWeight: 500 }}>💬 {post.replies.length} {post.replies.length === 1 ? "reply" : "replies"}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}


// ─── BLOG ────────────────────────────────────────────────────

export { Community };
